/**
 * A course card before its content arrives.
 *
 * Shaped like the real header rather than a plain block: the same card
 * border, the same 36px number circle, a title and a right-hand slot. It
 * stands in the space the loaded row will occupy, so the section does not
 * jump when the data lands.
 */
export const CourseAccordionSkeleton = () => (
  <div className="flex items-center gap-4 rounded-2xl border border-border-secondary bg-card p-5">
    <div className="h-9 w-9 shrink-0 animate-pulse rounded-full bg-muted" />
    <div className="h-4 w-full max-w-[18rem] animate-pulse rounded bg-muted" />
    <div className="ml-auto h-4 w-16 shrink-0 animate-pulse rounded bg-muted" />
    <div className="h-5 w-5 shrink-0 animate-pulse rounded bg-muted" />
  </div>
);
